import React, { useState, useEffect } from "react";
import { useLanguage } from "./LanguageContext";
import { getAllLanguages } from "../../../data-sources/api";

/**
 * LanguageSelector component that allows users to select a language from a list.
 * 
 * @returns {JSX.Element} The rendered language selector component.
 */
export function LanguageSelector() {
  const [languages, setLanguages] = useState([]);
  const { language, setLanguage } = useLanguage();

  /*
   * Fetches all languages on component render
   */
  useEffect(() => {
    getAllLanguages()
      .then((response) => {
        setLanguages(response.data);
        console.log("fetched languages from Sadima API");
      })
      .catch((error) => {
        console.error("Error fetching languages:", error);
      });
  }, []);


  return (
    <div className="language-selector-container">
      <div className="language-option">
        {languages.map((lang) => (
          <div
            key={lang.id}
            className={`language-text light-text ${lang.id === language.id ? 'selected-language' : ''}`}
            onClick={() => setLanguage(lang)}
          >
            {lang.languageText}
          </div>
        ))}
      </div>
    </div>
  );
}
